export default __webpack_public_path__ + "static/media/049-snorkel.c19c87c3.png";